import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {BrowserModule} from "@angular/platform-browser";

import {blankComponent} from "./blank.component";
import {basicComponent} from "./basic.component";
import {notFoundComponent} from "./not-found.component";

import {NavigationModule} from "../navigation/navigation.module";
import {TopnavbarModule} from "../topnavbar/topnavbar.module";
import {FooterModule} from "../footer/footer.module";

@NgModule({
    declarations: [blankComponent, basicComponent, notFoundComponent],
    imports     : [BrowserModule, RouterModule, NavigationModule, TopnavbarModule, FooterModule],
    exports     : [blankComponent, basicComponent, notFoundComponent]
})

export class LayoutsModule {}



// WEBPACK FOOTER //
// ./src/app/components/common/layouts/layouts.module.ts